var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sms-input-card" }, [
    _c("div", { staticClass: "form-section" }, [
      _vm.senders && _vm.senders.length > 0
        ? _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "field-label" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("badge")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.defaultSender")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "field-control",
                  attrs: {
                    size: "large",
                    placeholder: _vm.$t("message.selectSender"),
                  },
                  model: {
                    value: _vm.senderId,
                    callback: function ($$v) {
                      _vm.senderId = $$v
                    },
                    expression: "senderId",
                  },
                },
                _vm._l(_vm.senders, function (sender) {
                  return _c(
                    "a-select-option",
                    { key: sender.uuid, attrs: { value: sender.title } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(sender.title) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "field-label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.recipient")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "phone-row" },
          [
            _c("vue-country-code", {
              staticClass: "country-code",
              attrs: { enabledCountryCode: true, defaultCountry: "TR" },
              on: {
                onSelect: function ($event) {
                  return _vm.onSelect($event)
                },
              },
            }),
            _vm._v(" "),
            _c("a-input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "############",
                  expression: "'############'",
                },
              ],
              attrs: {
                size: "large",
                placeholder: _vm.$t("message.phone"),
                autocomplete: "off",
                trim: "",
                type: "text",
              },
              model: {
                value: _vm.number,
                callback: function ($$v) {
                  _vm.number = $$v
                },
                expression: "number",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "field-label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("chat")]),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.messageContent")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "message-box" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("message.writeYourMessage"),
                "show-attributes": false,
                "show-emoji": true,
                "preview-mode": false,
                "whatsapp-mode": false,
                "allowed-attributes": false,
                "max-character-count": 160,
              },
              model: {
                value: _vm.text,
                callback: function ($$v) {
                  _vm.text = $$v
                },
                expression: "text",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "char-counter",
                class: {
                  warn: _vm.charCount > 140 && _vm.charCount <= 160,
                  over: _vm.charCount > 160,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.charCount) +
                    " / 160\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _vm.credit !== undefined && _vm.credit !== null
          ? _c("div", { staticClass: "credit-badge" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("account_balance_wallet"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "credit-label" }, [
                _vm._v(_vm._s(_vm.$t("message.remainingCredit")) + ":"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "credit-value" }, [
                _vm._v(_vm._s(_vm.credit)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a-button",
          {
            staticClass: "send-button",
            attrs: {
              type: "primary",
              size: "large",
              disabled: !_vm.formIsValid(),
            },
            on: { click: _vm.sendSMS },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("send")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.sendSms")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }